import { useQuery } from "@tanstack/react-query";
import Axios from "../../../Axios/Axios";
import { Urls } from "../../../Urls";

export const useIndentSummary = (
  { startDate, endDate, plant, transporterId, role, destination },
  enabled = true
) => {
  return useQuery({
    queryKey: ["indentSummary", startDate, endDate, plant, transporterId, role, destination],
    queryFn: async () => {
      const params = new URLSearchParams({ start_date: startDate, end_date: endDate });
      if (plant && plant !== "All") params.append("plant", plant);
      if (transporterId && transporterId !== "All") params.append("transporter_id", transporterId);
      if (role) params.append("role", role);
      if (destination && destination !== "All") params.append("destination", destination);
      const { data } = await Axios.get(`${Urls.tmsDashboardIndentSummary}?${params.toString()}`);
      return data;
    },
    enabled,
    staleTime: 60 * 1000,
    refetchInterval: enabled ? 5 * 60 * 1000 : false,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
  });
};
